import { useEffect } from "react";
import { useAppearanceStore } from "@/features/appearance/model/appearance-store";

// Keeps the <html data-theme> attribute in sync with the stored theme so the
// preference applies app-wide. Rendered once near the app root.
export const ThemeSync = () => {
  const theme = useAppearanceStore((s) => s.theme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return null;
};
